import { useTranslation } from 'next-i18next';
import React from 'react';
import { NetworkComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import EmptyComponent from '../../../pageBuilder/EmptyComponent';
import { TitleAndDescription } from '../../../pageBuilder/TitleAndDescription';
import Network from '../network/Network';

const NetworkComponent = ({ uiComponent }: UiComponentElementInterface<NetworkComponentInterface>) => {
  const networks = useSelector((state) => state.common.networks);

  const { t } = useTranslation('pagebuilder');

  return (
    <>
      <TitleAndDescription component={uiComponent!} />
      {networks && networks?.length > 0 ? (
        <div
          style={{
            color: uiComponent?.styling?.textColor || '#000',
          }}>
          <Network networksFilter={uiComponent?.networks} uiComponent={uiComponent} />
        </div>
      ) : (
        <EmptyComponent componentName={t('pagebuilder:network')} />
      )}
    </>
  );
};

export default NetworkComponent;
